module.exports = __webpack_public_path__ + "img/con3-head.11c77573.png";